import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import { LOADING } from 'stores/BaseStore';

import { Card, Loader, CardSubtitle } from './card';

const propTypes = {
  field: PropTypes.string,
  data: PropTypes.any,
  data2: PropTypes.any,
  total: PropTypes.any,
};

const formatMoney = value => <NumberFormat value={value} displayType="text" thousandSeparator="," decimalSeparator="." prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

const formatNumber = value => <NumberFormat value={value} displayType="text" thousandSeparator="," />

export default function SimpleCard({ status, data, title, total, isMoney }) {
  return <Card className='h-19'>
    <Loader loading={status === LOADING || !data}>
      {title}
      <CardSubtitle>
        {isMoney ? formatMoney(total ? total - data : data) : formatNumber(data)}
      </CardSubtitle>
    </Loader>
  </Card>
}

SimpleCard.propTypes = propTypes;
